import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "../../../_assets/css/custom.css";
import "react-owl-carousel2/lib/styles.css";
import { postMethod } from "../../../_services/_postMethod";
import AddProduct from "../branch/products/addproduct";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { API_BASE_URL } from "../../../_services/constant";
import OwlCarousel from "react-owl-carousel2";
import Slide from "@material-ui/core/Slide";
import CustomerHeader from "./components/header";
import CustomerFooter from "./components/footer";
import CustomerBanner from "./components/banner";
import CustomerVoucherCom from "./components/voucher";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#000',
    backgroundColor: '#fff'
  },
  productCard: {
    background: '#fff',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 6px 24px rgba(0,0,0,0.13)',
    },
  },
  imageContainer: {
    width: '100%',
    aspectRatio: '1 / 1',
    overflow: 'hidden',
    background: '#f8f8f8',
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  cardContent: {
    padding: '10px 12px 12px',
  },
  productTitle: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#222',
    marginBottom: 4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  metaText: {
    fontSize: '0.75rem',
    color: '#777',
    display: 'block',
    marginBottom: 2,
  },
  priceRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 4,
  },
  currentPrice: {
    fontSize: '0.88rem',
    fontWeight: 700,
    color: '#222',
  },
  originalPrice: {
    fontSize: '0.78rem',
    color: '#999',
    textDecoration: 'line-through',
  },
}));

const CustomerProductview = (props) => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm();

  const normalizeColor = (color) => {
    if (!color) return 'transparent';
    const colorMap = {
      'gold': '#FFD700', 'rose gold': '#b76e79', 'rosegold': '#b76e79',
      'silver': '#C0C0C0', 'white gold': '#e8e8e8', 'whitegold': '#e8e8e8',
      'yellow gold': '#FFD700', 'yellowgold': '#FFD700',
      'platinum': '#E5E4E2', 'black': '#222', 'white': '#f5f5f5',
      'red': '#e53935', 'blue': '#1e88e5', 'green': '#43a047',
      'pink': 'pink', 'purple': 'purple', 'orange': 'orange',
      'brown': '#795548', 'grey': '#9e9e9e', 'gray': '#9e9e9e',
    };
    const normalized = color.toLowerCase().replace(/\s+/g, '');
    if (colorMap[normalized]) return colorMap[normalized];
    if (colorMap[color.trim().toLowerCase()]) return colorMap[color.trim().toLowerCase()];
    const words = color.trim().split(/\s+/);
    if (words.length > 1) return words[1].toLowerCase();
    return normalized;
  };
  const [isvalid, setValid] = useState(false);
  const [load, setLoad] = useState(false);
  const inputRef = React.createRef(null);
  const [voucherList, setVoucherList] = useState([]);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [products, setProducts] = useState([]);

  const [productCount, setProductCount] = React.useState(0);
  const [product, setProduct] = useState([
    {
      product_id: "",
      product_code: "",
      Metal: "",
      discounted_price: "",
      price: "",
      product_name: "",
      remarks: "",
      weight: "",
      size_length: "",
      trial: false
    },
  ]);
  const [productImages, setProductImages] = useState([]);
  const [productImage, setProductImage] = useState("");
  const optionsSimilar = {
    responsive: {
      0: {
        items: 2

      },
      600: {
        items: 2,

      },
      1000: {
        items: 4

      }
    },
    dots: false,
    margin: 20,
    autoplay: true,
    // center:true,
    stagePadding: 10,
    loop: false,
    nav: false,
  };
  const optionsProduct = {
    responsive: {
      0: {
        items: 1,
        margin: 10
      },
      600: {
        items: 1,
        margin: 10
      },
      1000: {
        items: 1,
        margin: 10
      }
    },
    // dots: false,    
    autoplay: false,
    center: true,
    stagePadding: 10,
    loop: true,
    nav: true,
  };

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const AddProductList = (type) => {
    postMethod("api/session/add_to_cart", {
      product_id: product.product_id,
      price: product.discounted_price,
      added_from: "general",
      type: type,
    }).then((data) => {
      if (type == "wish") {
        setSnackbarMsg("Product added to wish list. Customer executive will contact you soon.");
      }
      else {
        setSnackbarMsg("Product added to trial. Customer executive will contact you soon.");
      }
      handleClick();
      postMethod("api/session/wishlist", {}).then((data) => {
        setProductCount(data.data.length);
      });
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoad(true);
    postMethod("api/session/products_view", {
      product_id: localStorage.getItem("product_id"),
    }).then((dataD) => {
      var data = dataD.data;
      setProduct(data[0][0]);
      setProductImage(data[1][0].image_path);
      setProductImages(data[1]);
      postMethod("api/session/all_similar_product_list_general", {
        category_id: localStorage.getItem("category_id"),
        min_price: 0,
        max_price: data[0][0].price,
        metal: data[0][0].Metal,
        material: data[0][0].material,
        subcategory_id: "0",
        skip: "0",
      }).then((data) => {
        // alert(JSON.stringify(data));
        var result = data.data.filter((item) => item.product_id != localStorage.getItem("product_id"));
        setProducts(result);
      });
      setLoad(false);
    });


  }, []);

  const RedirectToProduct = (product_id) => {
    window.scrollTo(0, 0);
    localStorage.setItem("product_id", product_id);
    window.location.reload();
  };


  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop} open={load} >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div>
        <Snackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          message={snackbarMsg}
        />
      </div>
      <CustomerHeader count={productCount} />
      <div className="clr"></div>
      <div className="container-fluid toppadhead">
        <div className="row toppad5 mtoppad2">
          <div className="container">
            <div className="catsectionbx">
              <div className="row no-gutters">
                <div className="col-md-2 d-none d-md-block col-lg-1 order-2 order-md-1">
                  <div className="thumbnail">
                    <ul className="list-unstyled p-0 d-flex d-md-block flex-wrap mt-3 mt-md-0">
                      {productImages.length > 0 ? productImages.map((pr, index) => {
                        if (index < 4) {
                          return <li key={index}>
                            <div className="thumb shadow-sm">
                              <img
                                src={
                                  pr?.isImageUrl
                                    ? pr.image_path
                                    : `${API_BASE_URL}Images/${pr?.image_path || ""}`
                                }
                                onClick={() => {
                                  if (window.outerWidth > 600) {
                                    setProductImage(pr.image_path);
                                  } else {
                                    console.log(inputRef.current);
                                    inputRef.current.goTo(3);
                                  }
                                }}
                                className="w-100"
                              />
                            </div>
                          </li>
                        }
                      }) : null}

                    </ul>
                  </div>
                </div>
                <div className="col-md-10 col-lg-6 d-none d-lg-block d-md-block order-1 text-md-center text-lg-left order-md-2">
                  <img
                    style={{ height: 400, width: 423 }}
                    src={
                      productImages?.[0]?.isImageUrl
                        ? productImages[0].image_path
                        : `${API_BASE_URL}Images/${productImages?.[0]?.image_path || ""}`
                    }
                  />
                </div>
                <div className=" col-sm-5 d-none d-lg-none d-md-none d-block productSlide">
                  {productImages.length && (
                    <div className="productSlides">
                      <OwlCarousel ref={inputRef} options={optionsProduct}>
                        {productImages.map((prop, i) => (
                          <img
                            src={
                              prop?.isImageUrl
                                ? prop.image_path
                                : `${API_BASE_URL}Images/${prop?.image_path || ""}`}
                            style={{ width: "100%", height: 350, objectFit: 'contain' }}
                            className="img-fluid "
                            alt=""
                          />
                        ))}
                      </OwlCarousel>
                    </div>
                  )}
                </div>
                <div className="col-md-12 col-lg-5 prv mtoppad3 order-3 order-md-3">
                  <div className="mtoppad2">
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                  </div>
                  <h2 className="toppad1" style={{ display: 'flex', alignItems: 'center' }}>
                    {product.product_name}
                    {(product.color || product.Color) && (
                      <span
                        title={product.color || product.Color}
                        style={{
                          width: '18px',
                          height: '18px',
                          borderRadius: '50%',
                          backgroundColor: normalizeColor(product.color || product.Color),
                          border: '1px solid rgba(0,0,0,0.15)',
                          display: 'inline-block',
                          marginLeft: '10px',
                          flexShrink: 0,
                        }}
                      />
                    )}
                    <span className="ml-2">
                      <a href="#section2">Product Details</a>
                    </span>
                  </h2>
                  <p>{product.remarks}</p>

                  {(localStorage.getItem("jwl_hide_price") == 'false' || localStorage.getItem("jwl_hide_price") == false) ?
                    <div className="price">
                      {product.discounted_price !== 0 &&
                        product.discounted_price !== null &&
                        product.discounted_price !== undefined ? (
                        <>
                          ₹ {product.discounted_price}{" "}
                          <span className="greytxt lpadd1">
                            <del>₹ {product.price}</del>
                          </span>
                        </>
                      ) : (
                        <>₹ {product.price}</>
                      )}
                    </div> : null
                  }

                  <div className="row toppad5">
                    {product.material != "" ?
                      <div className="col-6 col-sm-6 col-lg-4 btnpad">
                        <div className="form-group">
                          <label for="inputState">Material</label>
                          <select id="inputState" className="form-control" disabled={true}>
                            <option selected>{product.material}</option>

                          </select>
                        </div>
                      </div>
                      : null}
                    {product.material != "" ?
                      <div className="col-6 col-sm-6 col-lg-4 btnpad">
                        {/* <div className="form-group">
                        <label for="inputState">Metal</label>
                        <select id="inputState" className="form-control" disabled={true}>
                          <option selected> {product.Metal}</option>
                        </select>
                      </div> */}
                      </div>
                      : null}
                  </div>
                  <div className="row toppad5 mtoppad2 wishBtn">
                    {product.trial == true ? (
                      <>
                        <div className="col-6 col-sm-6 col-lg-4 btnpad">
                          <button
                            className="allbtn"
                            type="button"
                            onClick={() => AddProductList("wish")}
                          >
                            Add to Wish List
                          </button>
                        </div>
                        <div className="col-6 col-sm-6 col-lg-4 btnpad">
                          <button
                            className="trybtn"
                            type="button"
                            onClick={() => AddProductList("trial")}
                          >
                            Try Before you Buy
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="col-12 col-sm-12 col-lg-8 btnpad">
                        <button
                          className="allbtn"
                          type="button"
                          onClick={() => AddProductList("wish")}
                        >
                          Add to Wish List
                        </button>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clr"></div>
      <div className="container-fluid py-5">
        <div className="container prvdtl">
          <div className="row" id="section2">
            <div className="col-12">
              <h3>Product Details</h3>
            </div>
            <div className="col-12 col-sm-12 col-lg-4">
              <ul className="p-0">
                <li><b>Product code:</b> {product.product_code}</li>
                <li><b>Name</b> - {product.product_name}</li>
                <li>
                  <b>Name</b> - {product.product_name}
                </li>
                {
                  product.Metal ?
                    <li>
                      <b>Metal</b> - {product.Metal}
                    </li> : null
                }
                {
                  product.package ?
                    <li>
                      <b>Package</b> - {product.package}
                    </li> : null
                }
                {
                  product.ptype ?
                    <li>
                      <b>Product Type</b> - {product.ptype}
                    </li> : null
                }
                {
                  product.pattern ?
                    <li>
                      <b>Pattern</b> - {product.pattern}
                    </li> : null
                }
                {
                  product.size_length ?
                    <li>
                      <b>Size</b> - {product.size_length}
                    </li> : null
                }
                {
                  product.color ?
                    <li>
                      <b>Color</b> - {product.color}
                    </li> : null
                }

                <li>
                  <b>Material</b> - {product.material}
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      {products && products.length > 0 ? (
        <section className="similarProducts bg-light py-5">
          <div className="container">
            <div className="uniq">
              <h2 className="text-left">Similar Products</h2>
            </div>
            <OwlCarousel ref={inputRef} options={optionsSimilar}>
              {products.map((prop, i) => (
                <div
                  key={"product" + i}
                  className={classes.productCard}
                  onClick={() => RedirectToProduct(prop.product_id)}
                >
                  <div className={classes.imageContainer}>
                    <img
                      className={classes.cardImage}
                      src={
                        prop?.isImageUrl
                          ? prop.image_path
                          : `${API_BASE_URL}Images/${prop?.image_path || ""}`
                      }
                      style={{ objectFit: "contain" }}
                      alt={prop.product_name}
                    />
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.productTitle} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{prop.product_name}</span>
                      {(prop.color || prop.Color) && (
                        <span
                          title={prop.color || prop.Color}
                          style={{
                            width: '14px',
                            height: '14px',
                            borderRadius: '50%',
                            backgroundColor: normalizeColor(prop.color || prop.Color),
                            border: '1px solid rgba(0,0,0,0.15)',
                            display: 'inline-block',
                            flexShrink: 0,
                            marginLeft: '8px',
                          }}
                        />
                      )}
                    </div>
                    {prop.size_length && (
                      <span className={classes.metaText}>
                        Size: <strong style={{ color: '#555' }}>{prop.size_length}</strong>
                      </span>
                    )}
                    {(localStorage.getItem("jwl_hide_price") === 'false' || localStorage.getItem("jwl_hide_price") == false) && (
                      <div className={classes.priceRow}>
                        {prop.discounted_price != 0 && prop.discounted_price ? (
                          <>
                            <span className={classes.currentPrice}>₹ {prop.discounted_price}</span>
                            <span className={classes.originalPrice}>₹ {prop.price}</span>
                          </>
                        ) : (
                          <span className={classes.currentPrice}>₹ {prop.price}</span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </section>
      ) : null}
      <div className="  toppad3 botmargn3 slideVoucher pb-10 mb-6 mb-md-0 ">

        <div className=" mt-4 mb-5 mb-md-4 px-0">
          {/* <CustomerVoucherCom/> */}
        </div>
      </div>
      {window.outerWidth > 600 ? <CustomerFooter /> : null}
    </React.Fragment>
  );
};

export default CustomerProductview;

